import { AxiosResponse } from "axios";
import { api } from "../api";
import { GetAuditLogsParams, PaginatedAuditLogsResponse } from "./audit.types";

export const getAuditLogs = async (
  params: GetAuditLogsParams
): Promise<PaginatedAuditLogsResponse> => {
  try {
    const response: AxiosResponse<PaginatedAuditLogsResponse> = await api.get(
      "/audit-logs",
      { params }
    );

    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch audit logs:", error);
    throw error;
  }
};
